import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { offer } from '../../data/offer';
import { PendingNote } from '../ui/PendingNote';
export function GuaranteeSection() {
  return <section className="bg-mint py-16 sm:py-24" data-id="element-59" data-mp="1kblyvk4xodmh">
      <div className="mx-auto flex max-w-[760px] flex-col items-center px-5 text-center sm:px-8" data-id="element-60" data-mp="1ka16o163d6rs">
        <span className="grid h-24 w-24 place-items-center rounded-full border-4 border-white bg-petrol text-white shadow-card" data-id="element-61" data-mp="1fciv030owdg3">
          <ShieldCheckIcon className="h-11 w-11" aria-hidden="true" data-id="element-62" data-mp="15el8bjyhaopl" />
        </span>
        <p className="mt-6 text-xs font-bold uppercase tracking-[.2em] text-teal" data-id="element-63" data-mp="15gpmqvu07644">Buy with confidence</p>
        <h2 className="mt-3 font-display text-[44px] font-extrabold uppercase leading-[.95] text-petrol sm:text-[58px]" data-id="element-64" data-mp="11eulfrc2osqc">
          {offer.guaranteeDays ? <>
              <span className="text-teal" data-id="element-65" data-mp="2vqiuxdzjc33c">{offer.guaranteeDays}-day</span> guarantee
            </> : 'Our guarantee'}
        </h2>
        {offer.guaranteeTerms ? <p className="mt-5 text-[17px] leading-relaxed text-slate" data-id="element-66" data-mp="1g3imiu5ubgva">{offer.guaranteeTerms}</p> : <PendingNote className="mt-6" data-id="element-67" data-mp="1l1twd4w4xrdi">Exact guarantee terms (days and conditions)</PendingNote>}
      </div>
    </section>;
}